import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '../lib/api'
import type { EventTag, EventTagCategory } from '@fellowship/shared'

// Public list of active filter tags (dietary / audience). Used by event forms,
// the Discover filter, and event detail chips. Admin-managed via the super admin
// page, so this is the single source of truth for which tags exist + their labels.
export function useEventTags() {
  return useQuery({
    queryKey: ['event-tags'],
    queryFn: () => apiFetch<{ data: EventTag[] }>('/event-tags'),
    select: (res) => res.data,
    staleTime: 5 * 60 * 1000,
  })
}

/** Convenience: a slug→label map for rendering tag chips on event detail. */
export function useEventTagLabels(): Record<string, string> {
  const { data } = useEventTags()
  const map: Record<string, string> = {}
  for (const t of data ?? []) map[t.slug] = t.label
  return map
}

export function tagsByCategory(
  tags: EventTag[] | undefined,
  category: EventTagCategory,
): EventTag[] {
  return (tags ?? []).filter((t) => t.category === category)
}
